module.exports = __webpack_public_path__ + "static/img/wnat_baby.af3f7e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/logo/wnat_baby.png
// module id = /8u8
// module chunks = 1